export enum StorageItem {
  Token = 'accessToken',
  OnboardingFreeUrl = 'onboardingFreeUrl',
  ShowContactButtonOnboarding = 'showContactButtonOnboarding',
  LoggedBy = 'loggedBy'
};
